'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var svgIcon = require('./svg-icon-501cae97.js');

var Trash = function (_a) {
    var dataCy = _a.dataCy, className = _a.className, variant = _a.variant, size = _a.size, svgProps = tslib_es6.__rest(_a, ["dataCy", "className", "variant", "size"]);
    return (React__default.createElement(svgIcon.SvgIcon, tslib_es6.__assign({ viewBox: "0 0 13 16", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", className: className, variant: variant, size: size, "data-cy": dataCy }, svgProps),
        React__default.createElement("path", { fill: "currentColor", d: "M1.6386 14.2222C1.6386 15.2 2.42515 16 3.3865\n      16H10.3781C11.3394 16 12.126 15.2 12.126\n      14.2222V3.55556H1.6386V14.2222ZM12.9999\n      0.888889H9.94112L9.06717 0H4.69742L3.82347\n      0.888889H0.764648V2.66667H12.9999V0.888889Z" })));
};

exports.Trash = Trash;
